/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import activeNodeImg from '../../images/active-nlw.png';
import inActiveNodeImg from '../../images/inactive-nlw.png';

interface attributeType {
    addon_code: string,
    attribute_name: string,
    selection_type: string,
}
interface customData {
    totalNodes:number,
    availableNodes:number,
    planCode: string,
    fixAttributes:string[],
   attributes:attributeType[],
  frontend_base_suburl:string,
  protocolName:string,
  cardType:string
}
const CardAllNetwork = ({
  totalNodes,
  availableNodes,
  fixAttributes,
  planCode,
  attributes,
  frontend_base_suburl,
  protocolName,
  cardType,
}: customData) => {
  const setImage = (val: string) => {
    const protocol_name = val.replace(/\s/g, '');
    switch (protocol_name.toLowerCase()) {
      case 'corda': return '../images/protocols/logos/corda_logo.svg';
      case 'r3': return '../images/protocols/logos/corda_logo.svg';
      case 'ethereum': return '../images/protocols/logos/ethereum_logo.svg';
      case 'credit': return '../images/protocols/logos/credits.png';
      case 'fabric': return '../images/protocols/logos/Hyperledger-Fabric_logo.svg';
      case 'sawtooth': return '../images/protocols/logos/sawtooth_logo.svg';
      case 'fluree': return '../images/protocols/logos/fluree_logo.svg';
      case 'phaeton': return '../images/protocols/logos/phaeton_logo.svg';
      case 'polygon': return '../images/protocols/logos/Polygonpos_logo.svg';
      case 'binance': return '../images/protocols/logos/binance_logo.svg';
      case 'tron': return '../images/protocols/logos/tron_logo.svg';
      case 'avalanche': return '../images/protocols/logos/avalanche_logo.svg';
      case 'axia': return '../images/protocols/logos/axia_logo.svg';
      case 'fantom': return '../images/protocols/logos/Fantom_logo.svg';
      case 'dcomm': return '../images/protocols/logos/dcommdark_logo.svg';
      case 'polkadot': return '../images/protocols/logos/Polkadot_logo.svg';
      case 'okc': return '../images/protocols/logos/okc_logo.svg';
      case 'aptos': return '../images/protocols/logos/Aptos_logo.svg';
      case 'coreum': return '../images/protocols/logos/Coreum_logo.svg';
      case 'shardeum': return '../images/protocols/logos/Shardeum_logo.svg';
      case 'energy-web': return '../images/protocols/logos/Energy_Web_Logo.svg';
      case 'polygon-edge': return '../images/protocols/logos/Polygon-Edge_logo.svg';
      case 'hyperledgerbesu': return '../images/protocols/logos/besu-icon.svg';
      case 'polygoncdkchain': return '../images/protocols/logos/Polygon_cdk.svg';
      case 'parachains': return '../images/protocols/logos/parachains_logo.svg';
      case 'cordaenterprise': return '../images/protocols/logos/corda_logo.svg';
      case 'provenanceblockchain': return '../images/protocols/logos/provenance_blockchain_logo.svg';
      case 'avalanche-subnets': return '../images/protocols/logos/avalanche_logo.svg';
      case 'bahamut': return '../images/protocols/logos/fastex_logo.svg';
      case 'zksyncera': return '../images/protocols/logos/zksyncera_logo.svg';
      case 'opstack': return '../images/protocols/logos/opstack_logo.svg';
      case 'arbitrumorbit': return '../images/protocols/logos/arbitrum_orbit_logo.svg';
      case 'shido': return '../images/protocols/logos/shido_logo.svg';

      default: return '';
    }
  };
  const getUrl = () => {
    if (cardType === 'public') {
      const arrStr = encodeURIComponent(JSON.stringify(attributes));
      for (const e of attributes) {
        if (e.attribute_name.toLowerCase() === 'staking' || e.attribute_name.toLowerCase() === 'validator' || e.attribute_name.toLowerCase() === 'validator node') {
          return `${frontend_base_suburl}/create/staking-network?count=${availableNodes}&planCode=${planCode}&attr=${arrStr}`;
        }
      }
      return `${frontend_base_suburl}/create/network?count=${availableNodes}&planCode=${planCode}&attr=${arrStr}`;
    }
    return frontend_base_suburl;
  };
  return (
        <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 effectCard cursor">
            <a href={getUrl()} className="nonActiveTextColor" style={{ textDecoration: 'none' }}>
            <div className="card workSpaceCard" style={{ height: '100%' }}>
                <div className="card-body">
                    <div className="d-flex justify-content-center">
                        <div className="col-12">
                            <img
                                src={setImage(protocolName)}
                                height="30px"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="mt-4 a-tag">
                            { attributes.map((data, idx) => (
                                <div key={`subcard${idx.toString()}`} className="d-flex mt-3 align-items-center">
                                    <div className="col-2 me-1">
                                        <img className="mx-1" src={activeNodeImg} alt="" />
                                    </div>
                                    <div className="col-10 my-auto ms-1">
                                        {data.attribute_name}
                                    </div>
                                </div>
                            )) }
                    </div>
                    { fixAttributes.map((data, idx) => (
                    <div key={`fixattr${idx.toString()}`} className="mt-3 mb-1 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2 me-1">
                                <img className="mx-1" src={inActiveNodeImg} alt="" />
                            </div>
                            <div className="col-10 my-auto ms-1">
                                {data}
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="card-footer a-tag">
                <div className="d-flex mt-1">
                    <div className="col-10">

                    <p className="mb-1 text-muted">
                    { cardType === 'public' && (
                        <>
                        {' '}
                        <span>Available:</span>
                       <span className="mx-3">
                            {availableNodes}
                            /
                            {totalNodes}
                            {' '}
                            Nodes
                       </span>
                        </>
                    )}
                    { cardType !== 'public' && (
                        <span>{protocolName}</span>
                    )}
                    </p>
                    </div>
                </div>
                </div>
            </div>
            </a>
        </div>

  );
};

export default CardAllNetwork;